module.exports = __webpack_public_path__ + "media/Audio19_l.b46d1e5d.wav";